import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { DialogVideoComponent } from './dialog-video.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [DialogVideoComponent],
  exports: [DialogVideoComponent],
})
export class TournamentsUiDialogVideoModule {}
